import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { playPause, updateColor } from '../../../redux/slices/visualSlice';

const HeapSort = ({ countIterations }) => {
  const myState = useSelector(state => state.updateProps);
  const dispatch = useDispatch();
  const timeoutsRef = useRef([]);
  const cancelledRef = useRef(false);

  const clearAllTimeouts = () => {
    cancelledRef.current = true;
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];
  };

  const schedule = (fn, delay) => {
    if (cancelledRef.current) return;
    const id = setTimeout(() => {
      if (!cancelledRef.current) fn();
    }, delay);
    timeoutsRef.current.push(id);
  };

  const solve = () => {
    const values = myState.values.map(item => item[0]);
    const ids = myState.values.map(item => item[1]);
    const speed = myState.speed;
    const color = myState.color;
    const slowMultiplier = 3;
    let timer = 0;

    const visualizeSwap = (i, j) => {
      const idI = ids[i];
      const idJ = ids[j];

      schedule(() => {
        const elI = document.getElementById(idI);
        const elJ = document.getElementById(idJ);
        elI.style.transform = `translateX(${j * 11}px)`;
        elJ.style.transform = `translateX(${i * 11}px)`;
        elI.childNodes[1].style.backgroundColor = 'black';
        elJ.childNodes[1].style.backgroundColor = 'black';
        schedule(() => {
          elI.childNodes[1].style.backgroundColor = color;
          elJ.childNodes[1].style.backgroundColor = color;
        }, speed * slowMultiplier - 10);
      }, timer * speed * slowMultiplier);

      [ids[i], ids[j]] = [ids[j], ids[i]];
      timer++;
    };

    const heapify = (arr, n, i) => {
      let largest = i;
      const left  = 2 * i + 1;
      const right = 2 * i + 2;
      if (left  < n && arr[left][0]  > arr[largest][0]) largest = left;
      if (right < n && arr[right][0] > arr[largest][0]) largest = right;
      if (largest !== i) {
        [arr[i], arr[largest]] = [arr[largest], arr[i]];
        visualizeSwap(i, largest);
        countIterations(i);
        heapify(arr, n, largest);
      }
    };

    const arr = values.map((v, idx) => [v, ids[idx]]);
    const n = arr.length;

    for (let i = Math.floor(n / 2) - 1; i >= 0; i--) heapify(arr, n, i);
    for (let i = n - 1; i > 0; i--) {
      [arr[0], arr[i]] = [arr[i], arr[0]];
      visualizeSwap(0, i);
      countIterations(i);
      heapify(arr, i, 0);
    }

    schedule(() => {
      dispatch(playPause(false));
      dispatch(updateColor('rgb(0, 182, 0)'));
    }, timer * speed * slowMultiplier + 50);
  };

  useEffect(() => {
    if (myState.algorithm === 'heap' && myState.play) {
      clearAllTimeouts();
      cancelledRef.current = false;
      solve();
    }
    return clearAllTimeouts;
  }, [myState.play]);

  useEffect(() => {
    return clearAllTimeouts;
  }, [myState.algorithm, myState.values]);

  return <></>;
};

export default HeapSort;
